import axios from "axios";
import { configUrl } from "../../config";

export const addCetRank = async (userId, rank) => {
    try {
        const response = await axios.post(`${configUrl.AssessmentServer}/api/User/AddRank/${userId}/${rank}`);
        return response;
    } catch (error) {
        console.error('Error adding rank to user:', error);
        throw error;
    }
};
